import React from 'react';
import Loader from '../../../components/Loader';
import { OTLink } from '../../../components/tag/OTLink';
import OTIcon from '../../../components/tag/OTIcon';
import { FormattedMessage } from 'react-intl';

const questionnaireStatus = (questionnaire) => {
 return (
     questionnaire.status === "NULL" ? 'questionnaire.status.ACTIVE' : questionnaire.status === "DRAFT" ? 'questionnaire.status.STARTED' : 'questionnaire.status.COMPLETED'
 )
}
const QLink = ({ qIsFetching, questionnaire }) => {
  if (qIsFetching) return <Loader />;
  else if (!questionnaire?.formulaFormId) {
    let link = '/questionnaires' + questionnaire.link;
    return (
      <li className="card-link-wrapper">
        <OTLink
          onClick={(e) => e.stopPropagation()}
          link={link}
          className="card-link"
        >

          {questionnaire.name} -{' '}
          <FormattedMessage
            id={`questionnaire.status.${questionnaire.status}`}
          />
        </OTLink>
      </li>
    );
  } else if (questionnaire?.formulaFormId) {
      let link = undefined;
      if(questionnaire.status === "NULL") {
          link = `/questionnaires/response/` + questionnaire.formulaFormId + '/' + questionnaire.formResponseId;
      } else if (questionnaire.status === "DRAFT") {
          link = '/questionnaires/fill/' + questionnaire.formulaFormId + '/' + questionnaire.formResponseId;
      } else if (questionnaire.status === "SUBMIT") {
          link = '/questionnaires/response/' + questionnaire.formulaFormId + '/' + questionnaire.formResponseId + '/true';
      }
      return (
          <li className="card-link-wrapper">
              <OTLink
                  onClick={(e) => e.stopPropagation()}
                  link={link}
                  className="card-link"
              >

                  {questionnaire.title} -{' '}
                  <FormattedMessage
                      id={questionnaireStatus(questionnaire)}
                  />
              </OTLink>
          </li>
      );
  }
};

export default QLink;
